import { OrganizationGridItem } from "@/components/organization/organization-grid-item";
import { NavLinkIconButton } from "@/components/ui/nav-link-icon-button";
import { Skeleton } from "@/components/ui/skeleton";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { cn } from "@/lib/utils";
import { getOrganizationGetMyOrganizationsQueryOptions, useOrganizationGetMyOrganizations } from "@/orval/organization";
import { createFileRoute } from "@tanstack/react-router";
import { SearchIcon } from "lucide-react";

const MyOrganizationsPage: React.FC = () => {
  const { data: organizations, isLoading, isFetching } = useOrganizationGetMyOrganizations();
  // const [searchString, setSearchString] = useState("");

  return (
    <div className="container min-w-0 px-4 sm:px-8">
      <h2 className="text-3xl font-semibold tracking-tight py-8 border-b text-foreground">My Organizations</h2>

      <div className="mt-4 flex min-w-0 flex-col items-stretch justify-between gap-4 sm:flex-row sm:items-center">
        <NavLinkIconButton
          to="/organizations"
          icon={<SearchIcon />}
          variant="outline"
          className="w-full justify-center sm:w-auto"
        >
          Find another organization
        </NavLinkIconButton>

        {/* <Input
          autoFocus
          className="ml-auto w-72"
          startAdornment={<SearchIcon size={22} className="px-1" />}
          placeholder="Search for an organization"
          value={searchString}
          onChange={(event) => setSearchString(event.target.value)}
        /> */}
      </div>

      <div className="mt-4 grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {isLoading ? (
          <>
            <Skeleton className="h-64" />
            <Skeleton className="h-64" />
            <Skeleton className="h-64 sm:hidden block" />
          </>
        ) : (
          organizations?.map((organization) => (
            <OrganizationGridItem
              key={organization.id}
              organizationListItem={organization}
              className={cn(isFetching && !isLoading && "opacity-50")}
            />
          ))
        )}
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_app/my/organizations")({
  loader: ({ context }) => ensureRouteQueryData({ context }, getOrganizationGetMyOrganizationsQueryOptions()),
  component: MyOrganizationsPage,
});
